import '../../assets/components/AdditionalProducts/additionalProducts.css';const d = "_additionalProductsContainer_1nwdb_1", o = "_additionalProductsFooter_1nwdb_2", t = "_additionalProducts_1nwdb_1", n = "_productCardLink_1nwdb_39", a = {
  additionalProductsContainer: d,
  additionalProductsFooter: o,
  additionalProducts: t,
  productCardLink: n
};
export {
  t as additionalProducts,
  d as additionalProductsContainer,
  o as additionalProductsFooter,
  a as default,
  n as productCardLink
};
